export const SERVER_URL = process.env.REACT_APP_API_ENDPOINT;
export const signupApi = SERVER_URL + "api/signup";
export const verifyMobileNumberApi = SERVER_URL + "api/verify_mobile";
export const verifyEmailApi = SERVER_URL + "api/verify_email";
export const loginApi = SERVER_URL + "api/login";
export const verifyMobileOtpApi = SERVER_URL + "api/verify_mobile_otp";
export const verifyEmailOtpApi = SERVER_URL + "api/verify_email_otp";
export const verifyOtpApi = SERVER_URL + "api/verify_otp";
export const sendOtpApi = SERVER_URL + "api/send_otp";
// Emergency contact OTP endpoints
export const sendEmailOtpApi = SERVER_URL + "api/send_email_otp";
export const sendMobileOtpApi = SERVER_URL + "api/send_mobile_otp";
export const verifyEmailOtpEmergencyApi = SERVER_URL + "api/verify_email_otp";
export const verifyMobileOtpEmergencyApi = SERVER_URL + "api/verify_mobile_otp";
export const fetchFormDataApi = SERVER_URL + "api/form";
export const fetchFormListApi = SERVER_URL + "api/forms";
export const saveFormDataApi = SERVER_URL + "api/form/save";
export const submitFormDataApi = SERVER_URL + "api/form/submit";
export const updateFormDataApi = SERVER_URL + "api/form/update";
export const createOrderApi = SERVER_URL + "api/pay/create-order";
export const verifyPaymentApi = SERVER_URL + "api/pay/verify-payment";
export const createShipmentApi = SERVER_URL + "api/shipment/create";
export const trackShipmentApi = SERVER_URL + "api/shipment/track";
export const shippingStatusApi = SERVER_URL + "api/orders";
export const adminUsersApi = SERVER_URL + "api/users";
export const verifyFormApi = SERVER_URL + "api/form/verify";
export const rejectFormApi = SERVER_URL + "api/form/reject";
export const pingApi = SERVER_URL + "api/ping";
export const readyApi = SERVER_URL + "api/ready";
export const getPreSignedUrlApi = SERVER_URL + "api/pre-signed-url";
export const getPublicKeyApi = SERVER_URL + "api/public_key";
export const getPublicInfoApi = SERVER_URL + "api/info";
export const alertApi = SERVER_URL + "api/alert";
export const adminViewFormApi = SERVER_URL + "api/view_form";
export const adminCardsApi = SERVER_URL + "api/cards";
export const adminAlertsApi = SERVER_URL + "api/alerts";
export const createCardApi = SERVER_URL + "api/create_card";
export const dialogActionsApi = SERVER_URL + "api/user/dialog_actions";
export const cardStatusApi = SERVER_URL + "api/card/status";
